import { createContext } from 'react';

import { Device } from '../types';

export const DeviceContext = createContext<{
  device: Device;
}>({
  device: 'mobile',
});
